export const WEB_APP_URL = process.env.NODE_ENV === 'production' ? 'https://www.app.retickin.com/?cta=viewevents' : 'https://retickin-fe-test.netlify.app/?cta=viewevents';
